var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-view"},_vm._l((_vm.events),function(event){return _c('EventCard',{key:event.guid,attrs:{"event":event},on:{"click":function($event){return _vm.addEventFilter(event.guid)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }